var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lb-bloco ",style:(_vm.fundo != '' ? 'background-color:' + _vm.fundo : '')},[_c('h6',{staticClass:"waves-effect",style:(_vm.descricao ? 'margin-top: 0' : '')},[_c('strong',[_vm._v(_vm._s(_vm.titulo))])]),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.descricao))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dfa629e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/template/TituloDestacado.vue
// module id = null
// module chunks = 